import { frameTypesAPI } from "@/views/Frames/Types/api";

export const getParamFrameTypes = async (body) => {
  try {
    const res = await frameTypesAPI.getParamFrameTypes(body);
    return res?.data;
  } catch (e) {}
};

export const frameTypeParamTable = [
  {
    name: "frame_param_link_id",
    label: "ID связки",
    field: "frame_param_link_id",
    align: "center",
    sortable: true,
  },
  {
    name: "frame_param_type_name",
    label: "Название типа параметра",
    field: "frame_param_type_name",
    align: "left",
  },
  {
    name: "frame_param_type_code",
    label: "Код типа параметра",
    field: "frame_param_type_code",
    align: "left",
  },
];
